var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoveIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1448_136686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30564 20.5 3.5 16.6944 3.5 12C3.5 7.30564 7.30564 3.5 12 3.5C16.6944 3.5 20.5 7.30564 20.5 12Z",
    fill: "url(#paint0_radial_1448_136686)",
    stroke: "#F6C64E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 13.9243C10.5171 13.9243 9.53258 13.7513 8.31558 13.5148C8.03708 13.4618 7.49658 13.5148 7.49658 14.3338C7.49658 15.9713 9.37808 18.0183 12.0001 18.0183C14.6221 18.0183 16.5036 15.9713 16.5036 14.3338C16.5036 13.5148 15.9626 13.4613 15.6846 13.5148C14.4676 13.7513 13.4836 13.9243 12.0001 13.9243Z",
    fill: "#7B481A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3249 4.64042C10.8954 3.42492 9.56295 2.78692 8.34695 3.21542C7.60895 3.47542 7.08645 4.07092 6.88295 4.76742C6.28745 4.35292 5.50745 4.21742 4.77045 4.47742C3.55545 4.90642 2.91645 6.23992 3.34595 7.45542C3.40695 7.62742 3.48795 7.78692 3.58195 7.93442C4.55745 9.72542 7.37595 10.9844 9.08245 10.9999C10.4009 9.91642 11.8054 7.16742 11.4414 5.16142C11.4224 4.98742 11.3849 4.81242 11.3249 4.64042ZM12.6749 4.64042C13.1044 3.42492 14.4374 2.78692 15.6529 3.21542C16.3909 3.47542 16.9134 4.07092 17.1174 4.76742C17.7129 4.35292 18.4929 4.21742 19.2299 4.47742C20.4449 4.90642 21.0834 6.23992 20.6549 7.45542C20.5934 7.62742 20.5129 7.78692 20.4184 7.93442C19.4429 9.72542 16.6244 10.9844 14.9174 10.9999C13.5989 9.91642 12.1949 7.16742 12.5589 5.16142C12.5774 4.98742 12.6149 4.81242 12.6749 4.64042Z",
    fill: "#E84C3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1448_136686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) rotate(90) scale(9)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC4D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1448_136686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIt);
export default __webpack_public_path__ + "static/media/loveIt.8a8f90784f80e49131c4ea1765d1d730.svg";
export { ForwardRef as ReactComponent };